<script setup lang="ts">
import { NButton, NCard } from 'naive-ui';
import { Capacitor } from '@capacitor/core';
import CapacitorLogin from '../components/b/capacitor-login.vue';
const authStore = useAuthStore();
const router = useRouter();
const tooManyRedirects = ref(false);
watch(
  tooManyRedirects,
  (nv) => {
    if (nv) checkEnv();
  },
  { immediate: true }
);
const redirectCounter = useLocalStorage('redirectCounter', 0);
const user = computed(() => authStore.user);
watch(
  user,
  (nv) => {
    if (!nv) return;
    redirectCounter.value = 0;
    router.push({ path: '/' });
  },
  { immediate: true }
);

const capacitorPlatform = ref(Capacitor.getPlatform());
const actAsNativeApp = computed(() => capacitorPlatform.value === 'ios' || capacitorPlatform.value === 'android');

watchEffect(() => {
  console.log({
    actAsNativeApp: actAsNativeApp.value,
    capacitorPlatform: capacitorPlatform.value,
    platform: Capacitor.getPlatform(),
  });
});
watchEffect(async () => {
  if (authStore.hydrated) {
    await authStore.tryFetchUser();
  }
  if (!user.value) {
    if (redirectCounter.value > 1) {
      console.warn('redirectCounter', redirectCounter.value);
      tooManyRedirects.value = true;
    } else if (!actAsNativeApp.value) {
      redirectCounter.value!++;
      location.href =
        import.meta.env.V_ID_BASE_URL +
        `/onboarding?returnurl=${encodeURIComponent(location.protocol + location.host + location.pathname)}&auto`;
    }
  }
});
const services = [
  import.meta.env.V_ANALYTICS_BASE_URL,
  import.meta.env.V_AUTH_BASE_URL,
  import.meta.env.V_CLOUD_BASE_URL,
  import.meta.env.V_CONFIG_BASE_URL,
  import.meta.env.V_DRAFTS_BASE_URL,
  import.meta.env.V_FEED_BASE_URL,
  import.meta.env.V_PAYMENTS_BASE_URL,
  import.meta.env.V_RENDER_BASE_URL,
  import.meta.env.V_TEMPLATES_BASE_URL,
  import.meta.env.V_STUDIO_RESOURCES_BASE_URL + '/api',
  import.meta.env.V_WORKSPACES_BASE_URL,
];
const checking = ref(false);
const status = reactive<Map<string, boolean | null>>(new Map<string, boolean | null>());
async function checkEnv() {
  checking.value = true;
  for (const s of services) {
    status.set(s, null);
    fetch(s)
      .then(() => {
        status.set(s, true);
      })
      .catch(() => {
        status.set(s, false);
      });
  }
}
function retry() {
  redirectCounter.value = 0;
  location.reload();
}
</script>

<template>
  <div class="p-4 flex justify-center items-center">
    <div v-if="!tooManyRedirects" class="text-center">
      <capacitor-login v-if="actAsNativeApp" />
      <p v-else>{{ $t('redirecting-to-sign-in') }}</p>
    </div>
    <template v-else>
      <n-card :title="$t('too-many-redirects-checking-services')">
        <div class="flex flex-col gap-2">
          <p v-for="[service, _status] of status.entries()">
            {{ service }}:
            <b
              :style="{
                color: _status === false ? 'red' : _status === true ? 'green' : undefined,
              }"
            >
              {{ _status ? $t('up') : $t('down') }}
            </b>
          </p>
        </div>
        <template #action>
          <div class="flex justify-end">
            <n-button @click="retry"> {{ $t('retry-2') }} </n-button>
          </div>
        </template>
      </n-card>
      <capacitor-login v-if="actAsNativeApp" />
    </template>
  </div>
</template>
